document.addEventListener("DOMContentLoaded", function () {
  const heroSliderEl = document.querySelector(".hero-banner--slider");
  if (heroSliderEl) {
    const dotsContainer = document.querySelector(".hero-banner__dots");
    const autoplayEnabled = heroSliderEl.dataset.autoplay === "true";
    const autoplayDelay = parseInt(heroSliderEl.dataset.delay, 10) || 5000;

    let autoplayInterval;

    const slider = new KeenSlider(heroSliderEl, {
      loop: true,
      slides: { perView: 1, spacing: 0 },
      created(s) {
        if (dotsContainer) {
          dotsContainer.innerHTML = "";
          s.track.details.slides.forEach((_slide, idx) => {
            const dot = document.createElement("button");
            dot.classList.add("hero-dot");
            dot.addEventListener("click", () => s.moveToIdx(idx));
            dotsContainer.appendChild(dot);
          });
          updateDots(s);
        }

        if (autoplayEnabled) startAutoplay(s);
      },
      slideChanged(s) {
        updateDots(s);
      },
      destroyed() {
        stopAutoplay();
      },
    });

    function updateDots(s) {
      const dots = dotsContainer.querySelectorAll(".hero-dot");
      dots.forEach((dot, idx) => {
        dot.classList.toggle("is-active", s.track.details.rel === idx);
      });
    }

    function startAutoplay(s) {
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        s.next();
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
    }
  }

  /* === USP auto-rotate on mobile === */
  const brandIcons = document.querySelectorAll(".hero-banner__brand-icon");
  let currentSlide = 1;
  setInterval(function () {
    if (window.innerWidth < 990) {
      brandIcons.forEach(icon => icon.classList.remove("active"));
      if (brandIcons[currentSlide]) {
        brandIcons[currentSlide].classList.add("active");
      } else return;

      currentSlide = currentSlide === brandIcons.length - 1 ? 0 : currentSlide + 1;
    }
  }, 5000);
});
